import React, { useMemo } from 'react';

interface OperationSettlementSummaryButtonProps {
  text: string;
  testId?: string;
  className?: string;
  onClick?: () => void;
  isClicked: boolean;
}

export const OperationSettlementSummaryButton: React.FC<
  OperationSettlementSummaryButtonProps
> = ({ text, testId, className, onClick = () => {}, isClicked }) => {
  const isClickedClass = useMemo(
    () => (isClicked ? 'bg-light-3' : 'bg-white hover:bg-light-2'),
    [isClicked]
  );

  const handleOnClick = () => {
    onClick();
  };

  return (
    <div
      className={`${isClickedClass} noto-medium-3 w-[110px] cursor-pointer rounded-[5px] border border-dark-6 text-dark-4 ${className}`}
      data-testid={testId}
      onClick={handleOnClick}
    >
      <p className="my-[3px] text-center leading-[23px]">{text}</p>
    </div>
  );
};
